import { Container, Text } from "@mantine/core";
import React from "react";

const Designer = () => {
  return (
    <Container>
      <Text className="text-center text-xl text-[#737373] border-b-yellow-500 border-b-2 w-[200px] mx-auto">
        DESIGNER CHOICE
      </Text>
      <div className="flex items-center flex-col md:flex-row justify-center gap-20 my-10">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flourve_img_1.png?alt=media&token=07d07a06-ff5f-40f0-91c6-36f3dfb1afb6"
          alt=""
          className="w-72"
        />
        <div className="flex flex-col text-[#737373]">
          <h1 className="text-xl text-[#456DA8]">DESIGNER COLLECTIONS</h1>
          <p className="my-5 tracking-widest leading-8">
            LOUVRE caters to thoughtful shoppers who appreciate unique designs
            and top quality.LOUVRE caters to thoughtful shoppers who appreciate
            unique designs and top quality.
          </p>
          <p className="text-xl">$ 1200</p>
          <p className="uppercase text-xs font-semibold mt-3">buy now</p>
        </div>
      </div>
      <div className="flex items-center flex-col md:flex-row justify-center gap-20 my-20">
        <div className="flex flex-col text-[#737373]">
          <h1 className="text-xl text-[#456DA8]">DESIGNER COLLECTIONS</h1>
          <p className="my-5 tracking-widest leading-8">
            LOUVRE caters to thoughtful shoppers who appreciate unique designs
            and top quality.LOUVRE caters to thoughtful shoppers who appreciate
            unique designs and top quality.
          </p>
          <p className="text-xl">$ 1200</p>
          <p className="uppercase text-xs font-semibold mt-3">buy now</p>
        </div>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flourve_img_2.png?alt=media&token=2ac873ff-c656-4193-a60b-0b4ce56142f2"
          alt=""
          className="w-72"
        />
      </div>
    </Container>
  );
};

export default Designer;
